// Brand feature flags with safe defaults.
//
// Only white-label brand configs (e.g. trainingcamp) export IS_WHITE_LABEL / DEFAULT_THEME_MODE;
// the LearnZapp brands (isc2, isaca, pmp, …) don't. Under CRA 5's `strictExportPresence`, a STATIC
// reference to a missing export — whether a named import (`import { IS_WHITE_LABEL }`) OR a static
// namespace member (`ns.IS_WHITE_LABEL`) — is a HARD compile error. So we read the values via a
// DYNAMIC key (`ns[variable]`), which webpack can't statically resolve and therefore can't flag,
// and fall back to a default. This is the single place shared code reads these flags.
import * as appConstant from "../../app_constant";

function flag(key, fallback) {
  const value = appConstant[key];
  return value === undefined ? fallback : value;
}

export const IS_WHITE_LABEL = flag("IS_WHITE_LABEL", false);

// Home "smart nudge" continuation card. Bundle-level launch flag (compile-time):
// only brand configs that opt in export NUDGE_CARD_ENABLED; everyone else stays
// false and shows no card. Flipping it is a release, not a live toggle.
export const NUDGE_CARD_ENABLED = flag("NUDGE_CARD_ENABLED", false);

// Bounded free-question set. Compile-time kill switch for the freemium change that
// makes every free door (Quick Set, Custom Test, Flashcards, Articles) draw from
// the per-domain num_questions/num_flashcards/num_articles free set instead of the
// full bundle, with the exhaustion modal + home card. DEFAULT ON everywhere (all
// brands + exams). A brand that needs to revert to full-bank behavior exports
// FREE_SET_ENFORCED = false; then every door behaves exactly as before this change
// — no pool restriction, no exhaustion checks, no modal, no card, no events.
export const FREE_SET_ENFORCED = flag("FREE_SET_ENFORCED", true);

// Metered article unlocks. Compile-time rollout flag: a brand config that
// exports METERED_ARTICLE_UNLOCKS = <number> gives free users that many
// permanent article unlocks per period (any domain; cadence from
// METERED_ARTICLE_PERIOD below) instead of the legacy
// first-num_articles-per-domain cap. null/absent = feature OFF → every article
// surface behaves exactly as before (legacy slicing, dead locked rows).
export const METERED_ARTICLE_UNLOCKS = flag("METERED_ARTICLE_UNLOCKS", null);

// Reset cadence for the article meter: 'week' (UTC ISO week, the default) or
// 'day' (UTC midnight). Only read when METERED_ARTICLE_UNLOCKS is set.
export const METERED_ARTICLE_PERIOD = flag("METERED_ARTICLE_PERIOD", "week");

// Cross-promo "Other Apps" catalog (passive, menu-reachable only — never in
// study flow). Default ON for every LearnZapp brand; white-label never
// cross-promotes, so the flag folds in IS_WHITE_LABEL rather than trusting
// each WL config to opt out. A brand can still export
// CROSS_PROMO_ENABLED = false to opt out individually.
export const CROSS_PROMO_ENABLED = flag("CROSS_PROMO_ENABLED", true) && !IS_WHITE_LABEL;

export const DEFAULT_THEME_MODE = flag("DEFAULT_THEME_MODE", "dark");
// Brand key for the @learnzapp/core theme palette registry. Only brands with a
// custom palette set it (e.g. trainingcamp); everyone else falls back to
// 'default' → the canonical LearnZapp scheme.
export const BRAND_THEME = flag("BRAND_THEME", "default");
